import React from 'react';
import { MainLayout } from '../../components/layout';
import LoginRecordList from './LoginRecordList';

const LoginRecordPage: React.FC = () => {
  return (
    <MainLayout title="登录记录">
      <LoginRecordList />
    </MainLayout>
  );
};

export default LoginRecordPage;
